import { deleteTag } from '../../apiCalls/TagRequests'
import RemoveTagModal from '../admin/portfolio/RemoveTagModal'
import { useAppContext } from 'context/AppContext'
import { IoMdAdd } from 'react-icons/io'
import styled from 'styled-components'
import { toTitleCase } from 'variables/general'
import { BiTrash } from 'react-icons/bi'

function TagFilterBar({
  active,
  setActiveTag,
  location,
  tags,
  setTags,
  setCategoryModal,
  fontColor,
  font,
  setTagRemovalModal,
  tagRemovalModal,
  ordered,
  setSortedPickerOpen,
  justifyContent,
}) {
  const [context, dispatch] = useAppContext()
  const deleteTagRequest = async () => {
    deleteTag(context.token, active.identifier).then((response) => {
      if (response.status === 204) {
        const temp = tags.filter((tag) => tag.identifier !== active.identifier)
        setTags(temp)
        setActiveTag(tags[0])
        dispatch({
          type: 'setAlertType',
          alertType: 'success',
        })
        dispatch({
          type: 'setAlertText',
          alertText: ['Tag successfully deleted'],
        })
      } else {
        dispatch({
          type: 'setAlertType',
          alertType: 'error',
        })
        dispatch({
          type: 'setAlertText',
          alertText: ['Could not delete tag'],
        })
        throw new Error(response.data)
      }
    })
  }

  const Buttons = tags.map((tag, index) => {
    return (
      <Button1
        id={tag.name}
        onClick={() => {
          setActiveTag(tag)
        }}
        active={active.name === tag.name}
        key={tag.name}
        index={active === tag ? 0 : index}
        showAmount={99}
        style={{ display: 'flex' }}
        data-cy={toTitleCase(tag.name)}
      >
        <H1 active={active.name === tag.name} font={font}>
          {toTitleCase(tag.name)}
        </H1>
      </Button1>
    )
  })

  return (
    <Flex>
      <Nav id="category-bar" justifyContent={justifyContent} showAmount={99} fontColor={fontColor}>
        {tagRemovalModal && (
          <RemoveTagModal
            isOpen={tagRemovalModal}
            setTagRemovalModal={setTagRemovalModal}
            tagName={toTitleCase(active.name)}
            deleteTagRequest={deleteTagRequest}
          />
        )}
        {Buttons}
        {location === 'admin' && (
          <>
            <Row2 onClick={() => setCategoryModal(true)} id="add-category">
              <OutLineAddIcon />
              Add Category
            </Row2>
            {active.name !== 'all' && (
              <Row2 onClick={() => setTagRemovalModal(true)} id="add-category">
                <TrashIcon />
                Remove {toTitleCase(active.name)}
              </Row2>
            )}
          </>
        )}
      </Nav>
    </Flex>
  )
}
export default TagFilterBar

const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 2em 0;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

const Nav = styled.nav`
  position: relative;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: ${(props) => props.justifyContent || 'center'};
  align-items: center;
  flex-wrap: wrap;
  padding: 0;
  font-family: ${(props) => !!props.font && props.font};
  color: ${(props) => (props.fontColor ? props.fontColor : 'var(--black)')};
  @media (max-width: 550px) {
    margin: 3.5em 0;
  }
`

const Button1 = styled.a`
  letter-spacing: 0.5px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  background-color: transparent;
  height: 3em;
  border: none;
  padding: 0;
  border-radius: 0.3em;
  text-transform: none;
  outline: none;
  font-size: 1em;
  position: ${(props) => (props.index >= props.showAmount ? 'absolute' : 'relative')};
  left: ${(props) => (props.index >= props.showAmount ? '-999px' : 'auto')};
  margin: 0.5em 1em;
  opacity: ${(props) => (props.active === true ? 'none' : '0.5')};
  box-shadow: none;
  :hover {
    opacity: 1;
  }
`

const H1 = styled.h4`
  font-weight: 400;
  font-size: 1.4em;
  color: inherit;
  margin: 0.3em 0.7em;
  display: flex;
  align-items: center;
  letter-spacing: 1px;
  padding: 0 0 2px 0;
  font-family: ${(props) => !!props.font && props.font};
  border-bottom: ${(props) => (props.active === true ? '1px solid' : 'none')};
  @media (max-width: 900px) {
    font-size: 16px;
    margin: 0.5em;
  }
`
// const OutlineSettingIcon = styled(AiOutlineSetting)`
//   box-sizing: content-box;
//   font-size: 20px;
//   margin: 0 8px 0 0;
//   opacity: 0.5;
//   cursor: pointer;
//   border-left: 10px solid transparent;
//   border-right: 10px solid transparent;
//   :hover {
//     opacity: 1;
//   }
// `

const TrashIcon = styled(BiTrash)`
  width: 30px;
  font-size: 1em;
  margin: 0 4px 0 0;
  cursor: pointer;
  :hover {
    opacity: 0.5;
    background-color: #fff2d9;
  }
`
const OutLineAddIcon = styled(IoMdAdd)`
  width: 30px;
  font-size: 1em;
  cursor: pointer;
  margin: 0 4px 0 0;
  :hover {
    opacity: 0.5;
    background-color: #fff2d9;
  }
`
// const Add = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   @media (max-width: 550px) {
//     width: 80vw;
//   }
// `
// const Header = styled.div`
//   position: relative;
//   top: 0;
//   height: 40px;
//   display: flex;
//   align-items: center;

//   font-weight: 400;
// `

// const Body = styled.div`
//   position: relative;
//   cursor: pointer;
//   display: flex;
//   flex-direction: column;
//   width: 230px;
//   left: -200px;
//   border-radius: 0.3em;
//   box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
//   background: white;
//   z-index: 99;
//   font-weight: 400;
//   color: var(--black);
//   @media (max-width: 550px) {
//     left: 0;
//   }
// `

const Row2 = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 4px;
  height: 50px;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;

  :hover {
    opacity: 0.5;
    background-color: #fff2d9;
  }
`

// const ColorIcon = styled(CgColorPicker)`
//   z-index: 5;
//   font-size: 18px;
//   cursor: pointer;
//   margin: 0 8px 0 0;
// `

// const FontIcon = styled(AiOutlineFontColors)`
//   z-index: 5;
//   font-size: 16px;
//   cursor: pointer;
//   margin: 0 8px 0 0;
// `
